import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

import styles from './EventDatails.module.css';
import Title from '../../components/Title';

export default function EventDetails() {
  const { url } = useParams();
  const [eventsData, setEventsData] = useState([]);

  useEffect(() => {
    axios.get(`https://back-cultura-sje-production.up.railway.app/eventos/${url}`, {})
      .then((response) => {
        setEventsData(response.data)})
      .catch((error) => {
        console.error('Erro ao buscar evento', error);
      })
  }, [url]);

  if (!eventsData) {
    return <div>Evento não encontrado</div>;
  }

  function formatarData(dataISO) {
    const data = new Date(dataISO);

    const dia = data.getDate();
    const mes = data.toLocaleDateString('pt-BR', { month: 'long' });
    const ano = data.getFullYear();

    const hora = data.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
    });

    return `Dia ${dia} de ${mes.charAt(0).toUpperCase() + mes.slice(1)} de ${ano} às ${hora}`;
  }

  return (
    <div className={styles.eventDetailPage}>
      <main className={styles.eventContainer}>
        <section className={styles.eventHeader}>
          <Title fontSize='3rem' color='var(--brown-300)'>{eventsData.nome}</Title>
        </section>

        <div className={styles.eventContent}>
          <section className={styles.eventInfo}>
            <div className={styles.infoCard}>
              <h2>Informações do Evento</h2>
              <div className={styles.infoGrid}>
                <div>
                  <h3>Data e Hora</h3>
                  <p>{formatarData(eventsData.data)}</p>
                </div>
                <div>
                  <h3>Localização</h3>
                  <p>{eventsData.local}</p>
                  <p>{eventsData.endereco}</p>
                </div>
              </div>
            </div>
          </section>

          <section className={styles.eventDescription}>
            <h2>Sobre o Evento</h2>
            <p>{eventsData.descricao}</p>
            
            {eventsData.imagem ? <div className={styles.gallery}>
                <img src={eventsData.imagem} alt={eventsData.nome} />
            </div> : ''}
          </section>
        </div>
      </main>
    </div>
  );
}